import React, { useEffect, useState } from 'react';
import { Faq } from './Faq';
import { PublicModule } from './PublicModule';
import { Framework } from '../layouts';
import { Banner } from './Banner';
import { Tabs } from './Tabs';
import { RegionTab } from './RegionTab';
import { useFeelgood } from '@/libs/useFeelgood';
import { TriggerKey } from '@/constants';
import { REGION_CONFIG } from '@/region-config';
import { NewAndUpdatedSection } from './new-and-updated/new-and-updated-section';
import {
  getPopMarket,
  getPopRegionByShopRegion,
  isPopMarketValid,
  POP_REGION_KEY,
  POP_REGION_LIST,
  usePopQuery,
} from '@/hooks/usePopQuery';
import { useUserModel } from '@/models';

const Homepage = () => {
  const { isLogin } = useUserModel();
  const [initRegion, setInitRegion] = useState('');
  const { setRegionQuery } = usePopQuery();
  useFeelgood(TriggerKey.Homepage);

  useEffect(() => {
    const market = getPopMarket() || '';
    const isValidMarket = isPopMarketValid(market);
    // 未登录时，默认是市场 > US
    if (isLogin === 0 || (isLogin === 1 && isValidMarket)) {
      const region = isValidMarket ? market : 'us';
      setInitRegion(region);
      setRegionQuery(region);
      return;
    }
    // 已登录时，market > query > storage > US
    if (isLogin === 1) {
      const queryRegion = (
        new URLSearchParams(location.search).get(POP_REGION_KEY) || ''
      ).toLowerCase();
      // 如果是有效市场直接选市场
      if (isPopMarketValid(queryRegion)) {
        setInitRegion(queryRegion);
        setRegionQuery(queryRegion);
      } else if (
        POP_REGION_LIST.includes(queryRegion) &&
        document.referrer.includes('.tiktokglobalshop.com')
      ) {
        // 如果是区域且从SellerCenter跳转，按区域获取市场
        const market = getPopRegionByShopRegion(queryRegion);
        setInitRegion(market);
        setRegionQuery(market);
        localStorage.setItem('university_shop_region', queryRegion);
      } else {
        const storageRegion = (
          localStorage.getItem('university_shop_region') || ''
        ).toLowerCase();
        const market = getPopRegionByShopRegion(storageRegion) || 'us';
        setInitRegion(market);
        setRegionQuery(market);
      }
    }
  }, [isLogin]);

  return (
    <Framework enableDarkHeader={true} hideFooter={false} hideSearch>
      <div className="mt-[-60px]">
        <Banner />
        <RegionTab isInitd={!!initRegion} />
        {REGION_CONFIG.shouldShowNewAndUpdatedSection && (
          <NewAndUpdatedSection />
        )}
        {initRegion ? <PublicModule /> : null}
        <Tabs isInitd={!!initRegion} />
        <Faq />
      </div>
    </Framework>
  );
};

export default Homepage;
